const triggers = [
  {
    svg: 'check',
    code: 'subscription_created',
    title: 't(Subscription Created)',
    text: 't(Subscription is created for service)'
  },
  {
    svg: 'dollar_sign',
    code: 'invoice_created',
    title: 't(Invoice Created)',
    text: 't(Invoice created for a subscription for service)'
  },
  {
    svg: 'repeat',
    code: 'renewal_success',
    title: 't(Subscription Renewed)',
    text: 't(Subscription renewal succeeded for service)'
  },
  {
    svg: 'triangle_alert',
    code: 'renewal_failure',
    title: 't(Subscription Not Renewed)',
    text: 't(Subscription renewal failed for service)'
  },
  {
    svg: 'dollar_sign',
    code: 'payment_method_expiring',
    title: 't(Subscription Payment Expiring)',
    text: 't(Payment method is expiring for service)'
  },
  {
    svg: 'dollar_sign',
    code: 'payment_method_expired',
    title: 't(Subscription Payment Expired)',
    text: 't(Payment method is expired for service)'
  },
  {
    icon: 'pause-cirle-o',
    code: 'subscription_paused',
    title: 't(Subscription Paused)',
    text: 't(Subscription is paused for service)'
  },
  {
    svg: 'bell',
    code: 'subscription_reminded',
    title: 't(Subscription Reminded)',
    text: 't(Subscription is paused and contact is reminded)'
  },
  {
    icon: 'ban',
    code: 'subscription_canceled',
    title: 't(Subscription Canceled)',
    text: 't(Subscription is canceled for service)'
  }
]

export default triggers
